<zag-card variant="interactive" (cardClick)="onCardClick()">
  <!-- Header: Icon/Color, Name, Type Badge and optional Delete button -->
  <div card-header class="zag-location-card__header">
    <div
      class="zag-location-card__icon-wrapper zag-icon-surface-gradient"
      [class.zag-location-card__icon-wrapper--fallback]="!location().color"
      [style.background-color]="location().color || null"
    >
      <span
        [zagIcon]="location().icon || 'location_on'"
        [style.color]="getIconColor(location().color)"
        class="zag-location-card__icon"
      ></span>
    </div>
    <div class="zag-location-card__text">
      <h3 class="zag-card-title">{{ location().name }}</h3>
      <span
        class="zag-location-card__type-badge"
        [class.zag-location-card__type-badge--physical]="
          location().type === 'physical'
        "
        [class.zag-location-card__type-badge--virtual]="
          location().type === 'virtual'
        "
      >
        {{ location().type }}
      </span>
    </div>
    @if (showDelete()) {
    <button
      type="button"
      class="zag-location-card__delete-btn"
      [disabled]="deleteDisabled()"
      [attr.aria-label]="deleteAriaLabel() || null"
      (click)="onDeleteClick($event)"
    >
      <span zagIcon="delete"></span>
    </button>
    }
  </div>

  <!-- Body: Description -->
  @if (location().description) {
  <p class="zag-location-card__description">{{ location().description }}</p>
  }
</zag-card>
